import { TextInput, TextInputProps } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

import styles from './TableSearchInput.module.scss';

type Props = Omit<TextInputProps, 'value' | 'onChange'> & {
    value: string;
    onChange: (value: string) => void;
};

const TableSearchInput = ({ value, onChange, placeholder, ...props }: Props) => (
    <TextInput
        {...props}
        classNames={{
            input: styles.input,
            section: styles.section,
        }}
        value={value}
        onChange={(e) => {
            onChange(e.currentTarget.value);
        }}
        placeholder={placeholder}
        aria-label={placeholder}
        leftSection={<IconSearch size={16} />}
        leftSectionPointerEvents="none"
        size="md"
        radius="xl"
        mb="md"
    />
);

export default TableSearchInput;
